import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
  get_dashboard_data_action
} from "../../../actions/common_action/dashboard_action";
import { award_event_id, BASE_URL, responseError, scoringRoundActionId, toastError } from "../../../utils/constants";
import Header from "../../../common_components/Header";
import Footer from "../../../common_components/Footer";
import moment from "moment";
import { fill_action } from "../../../actions/common_action/fillList_action";
import MobileHeader from "../../../common_components/mobileHeader";
class adminDasboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      downloadUrl: '',
      user_id: "",
      role_id: "",
      Name: "",
      Description: "",
      is_active: "",
      AdminDashboardData: [],
      totalCount: [],
      circularData: [],
      filteredData: [],
      juryData: [],
      statusFillList: [],
      roundFillList: [],
      round_id: '',
      isAccordionExpanded: false, juryReviewEndDate: '', daysToGo: ''
    };
    this.getAdminDashboardData = this.getAdminDashboardData.bind(this);
  }
  componentDidMount() {
    const tempData = localStorage.getItem("tempLoginData");

    if (tempData) {
      const userData = JSON.parse(tempData);
      sessionStorage.setItem("AwardsUserLoginData", JSON.stringify(userData));
      sessionStorage.setItem("loginAccesslist", JSON.stringify(userData["loginAccesslist"]));
      sessionStorage.setItem("user_id", userData["user_id"]);
      sessionStorage.setItem("email_address", userData["email_address"]);
      sessionStorage.setItem("user_name", userData["user_name"]);
      sessionStorage.setItem("role_id", userData["role_id"]);
      sessionStorage.setItem("jury_id", userData["jury_id"]);
      sessionStorage.setItem("accessToken", userData["accessToken"]);
      sessionStorage.setItem("refreshToken", userData["refreshToken"]);
      localStorage.removeItem("tempLoginData");
    }
    setTimeout(() => {
      this.setState({ isLoading: true });
      if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
        setTimeout(() => {
          this.props.navigate("/login");
        }, 500);
      }

      setTimeout(() => {
        {
          sessionStorage.getItem("role_id") == 2 ? (
            this.props.navigate("/login")
          ) : <></>
        }
      }, 10);
      const { user_id } = this.state;
      const sortUrl = BASE_URL.split("/api");
      this.setState({ downloadUrl: sortUrl[0] });
      this.setState({
        user_id:
          sessionStorage.getItem("user_id") == "" ||
            sessionStorage.getItem("user_id") == null
            ? ""
            : sessionStorage.getItem("user_id"),
      });
      const waitForAwardEventId = () => {
        const awardEventId = sessionStorage.getItem("award_event_id")||1;
        if (awardEventId != null) {
          this.getFillList(scoringRoundActionId, user_id, "", "");
          setTimeout(() => {
            this.getAdminDashboardData();
          }, 500);
        } else {
          setTimeout(waitForAwardEventId, 200);
        }
      };
      waitForAwardEventId();
    }, 200);
  }
  getFillList(value, user_id, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        user_id == "" || user_id == null ? null : user_id,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == scoringRoundActionId) {
            this.setState({
              roundFillList: data.data,
            });
          }

        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getAdminDashboardData() {
    this.props
      .get_dashboard_data_action()
      .then((data) => {
        if (data.error !== 1) {
          const juryReviewEndDate = data?.data?.[0]?.[0]?.['juryReviewEndDate'];
          const today = new Date(); // Current local date and time
          const reviewEndDate = new Date(juryReviewEndDate); // Provided date in ISO format
          const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
          const reviewEndDateUTC = Date.UTC(reviewEndDate.getFullYear(), reviewEndDate.getMonth(), reviewEndDate.getDate());
          const difference = reviewEndDateUTC - todayUTC;
          const daysToGo = Math.max(0, Math.ceil(difference / (1000 * 60 * 60 * 24)));
          this.setState({
            AdminDashboardData: data?.data?.[1],
            totalCount: data?.data?.[2]?.[0],
            circularData: data?.data?.[3],
            juryData: data?.data?.[4],
            juryReviewEndDate,
            daysToGo, // Store the calculated days
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
          if (data.msg == "Session expired! Please login again." || data.msg == "Token invalid") {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/");
            setTimeout(() => {
              toastError(data.msg);
            }, 2000);
          } else {
            toastError(data.data);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  navigateApplicationStatus(award_event_profile_id, award_name, type, status_name) {
    this.props.navigate(`/adminApplicationList`, {
      state: { award_event_profile_id: award_event_profile_id, award_name: award_name, dashboardCountType: type, status_name, status_name },
    });
  }


  render() {
    const { isLoading, AdminDashboardData, totalCount, circularData, downloadUrl, roundFillList, round_id, juryData, juryReviewEndDate, daysToGo } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div className="container-fluid main-box">
                <div className="row">
                  <div className="row" style={{ display: 'flex' }}>
                    <div className="col-9" style={{ flex: '1 1 auto' }}>
                      <h2 className="mb-3 dashboard-tit py-0 blog-name">
                        Dashboard
                        <span className="application-s"> Application summary by award category across different stages.</span>
                      </h2>
                      <div className="custom_table">
                        <div className="hack1">
                          <div className="hack2">
                            <table className="table table-bordered" id="dashboard-table">
                              <thead>
                                <tr style={{ background: '#E6E6E6' }}>
                                  <th style={{ width: '40%' }}>Category Name</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Draft</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Submitted</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Rejected</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Verified</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Partial Review</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Reviewed</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Shortlisted</th>
                                  <th style={{ width: '5%', textAlign: 'center' }}>Winner</th>
                                </tr>
                              </thead>
                              <tbody id="myTable">
                                {AdminDashboardData?.length > 0 ? (
                                  AdminDashboardData?.map((data) => (
                                    <tr key={data.award_event_profile_id}>
                                      <td>{data.award_name}</td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 2, 'Draft')}>
                                        {data.Draft_Count}
                                      </td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 3, 'Submitted')}>
                                        {data.Submitted_Count}
                                      </td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 4, 'Rejected')}>
                                        {data.Rejected_Count}
                                      </td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 5, 'Verified')}>
                                        {data.Verified_Count}
                                      </td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 6, 'Partial Reviewed')}>
                                        {data.Partial_Reviewed_Count}
                                      </td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 7, 'Reviewed')}>
                                        {data.Reviewed_Count}
                                      </td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 8, 'Shortlisted')}>
                                        {data.Nominated_Count}
                                      </td>
                                      <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }} onClick={() => this.navigateApplicationStatus(data.award_event_profile_id, data.award_name, 9, 'Winner')}>
                                        {data.Result_Declared_Count}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={8} className="text-center">
                                      No records found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3" style={{ flex: '0 0 25%', display: 'flex', flexDirection: 'column' }}>
                      <h2 className="mb-3 dashboard-tit py-0 blog-name">Circular</h2>
                      <div className="circular border circular-height" style={{ flex: '1', overflow: 'scroll' }}>
                        {circularData?.length > 0 ? (
                          circularData?.map((data, i) =>
                            data.circular_id ? (
                              <div key={i} className="aside-group border-bottom mb-2">
                                <ul className="p-0 m-0">
                                  <li className="d-flex justify-content-between align-items-center">
                                    <span className="tit-name" style={{ overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                      {data.title}
                                    </span>
                                    <span className="tit-date">{moment(data.circular_date).format('DD-MM-YYYY')}</span>
                                  </li>
                                  <li className="tit-date pb-2" style={{ overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                    {data.content}
                                  </li>
                                  <li className="tit-date pb-2 membership_file">
                                    <a href={`${downloadUrl + data.file_path}`} target="_blank" rel="noopener noreferrer">
                                      {data.file_path?.split('/').pop()}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            ) : null
                          )
                        ) : (
                          <div className="aside-group border-bottom">
                            <ul className="p-0 m-0">
                              <li className="tit-date"> </li>
                              <li className="tit-name"> No Circular Released</li>
                              <li className="tit-date pb-2"></li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
                <hr className="mt-1" />
                <div className="row">
                  <h5 className="mb-3 dashboard-tit  py-0">Jury review progress by award category.</h5>
                  <div className="col-md-4">
                    <div className="d-flex">
                      <label className="dashboard-tit w-auto mr-4 mt-2">Round</label>
                      <select
                        className="form-select"
                        name="TimeSlot"
                        value={round_id}
                        onChange={(e) => {
                          this.setState({ round_id: e.target.value });
                        }}
                      >
                        {roundFillList.map((data) => (
                          <option value={data.round_id}>{data.round_name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-3">
                    <label className="dashboard-tit mt-1">No of days to go: <span className="label-no">{daysToGo}</span></label>
                  </div>
                  <div className="custom_table mt-3">
                    <div className="hack1">
                      <div className="hack2">
                        <table className="table table-bordered" id="dashboard-table">
                          <thead>
                            <tr style={{ background: "#E6E6E6" }}>
                              <th style={{ width: "35%" }}>Category</th>
                              {/* Extract all unique jury names dynamically */}
                              {juryData?.length > 0 &&
                                Array.from(
                                  new Set(
                                    juryData?.flatMap((data) =>
                                      Object.keys(data).filter(
                                        (key) =>
                                          ![
                                            "jury_id",
                                            "award_event_id",
                                            "award_event_profile_id",
                                            "award_name", "seq_no"
                                          ].includes(key) // Exclude unwanted keys
                                      )
                                    )
                                  )
                                )?.map((juryName, index) => (
                                  <th key={index} style={{ width: "8%", textAlign: "center" }}>
                                    {juryName}
                                  </th>
                                ))}

                            </tr>
                          </thead>
                          <tbody id="myTable">
                            {juryData?.length > 0 ? (
                              juryData?.map((data, rowIndex) => {
                                // Extract unique jury keys again for each row
                                const juryKeys = Array.from(
                                  new Set(
                                    Object.keys(data).filter((key) => ![
                                      "jury_id",
                                      "award_event_id",
                                      "award_event_profile_id",
                                      "award_name", "seq_no"
                                    ].includes(key))
                                  )
                                );

                                return (
                                  <tr key={rowIndex}>
                                    <td>{data.award_name}</td>
                                    {juryKeys?.map((juryKey, colIndex) => (
                                      <td
                                        key={colIndex}
                                        className="text-center"
                                        style={{ color: data[juryKey] ? "#062EC1" : "#999" }}
                                      >
                                        {data[juryKey] || "-"}
                                      </td>
                                    ))}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  colSpan={
                                    juryData?.[0] ? Object.keys(juryData?.[0])?.length : 1
                                  }
                                  className="text-center"
                                >
                                  No records found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />

          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { get_dashboard_data_action, fill_action })(adminDasboard)
);
